import { render, staticRenderFns } from "./ClientEditHomeMember.vue?vue&type=template&id=81effdf6&scoped=true&"
import script from "./ClientEditHomeMember.vue?vue&type=script&lang=js&"
export * from "./ClientEditHomeMember.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditHomeMember.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81effdf6",
  null
  
)

export default component.exports